export default __webpack_public_path__ + "static/media/sponsor-star.780a278e.svg";